<div class="ic-label-payment">
  <span class="label-payment">{{ label }}</span>
</div>
